import { useEffect, useRef, useState } from "react";
import { useMutation } from "@apollo/client";
import "../assets/css/BreezeStyles.css";
import { FINALIZE_BREEZE_TRANSACTION } from "../graphql/mutations/breeze";

function BreezePaymentSuccess() {
  // const paymentDataRef = useRef(null);
  // const transactionIdRef = useRef(null);
  // const hasFinalizedPayment = useRef(false);
  // const breezePageIdRef = useRef(null);

  // const [finalizeBreezeTransaction] = useMutation(FINALIZE_BREEZE_TRANSACTION, {
  //   onCompleted: (data) => {
  //     const result = data?.finalizeBreezeTransaction;

  //     //  notify parent
  //     window.parent.postMessage(
  //       {
  //         type: "BREEZE_REQUEST",
  //         payload: {
  //           action: "FINALIZED",
  //           wcData: result.wcData,
  //           paymentdata: result.paymentdata,
  //         },
  //       },
  //       "*",
  //     );
  //   },
  // });

  // useEffect(() => {

  //   const handler = async (event) => {
  //     const { type } = event.data || {};

  //     console.log("Breeze - Event Handler");
  //     if (type === "FROM_PARENT") {
  //       const { payload } = event.data;

  //       console.log("Breeze-  FromPaarent", payload);

  //       if (payload?.action === "BreezePaymentUpdate") {
  //         console.log("Breeze - BreezePaymentUpdate");
  //         if (
  //           paymentDataRef.current &&
  //           breezePageIdRef.current &&
  //           !hasFinalizedPayment.current
  //         ) {
  //           hasFinalizedPayment.current = true;

  //           console.log("Breeze - Finalizing");

  //           await finalizeBreezeTransaction({
  //             variables: {
  //               breezePageId: breezePageIdRef.current,
  //               transactionId: transactionIdRef.current,
  //               paymentdata: paymentDataRef.current,
  //             },
  //           });
  //         }
  //       }
  //     }
  //   };

  //   window.addEventListener("message", handler);
  //   return () => window.removeEventListener("message", handler);
  // }, []);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <h1>Finalizing WowCloud Purchase</h1>
      <h2>Please remain here until you are redirected automatically</h2>
    </div>
  );
}

export default BreezePaymentSuccess;
